import { useRef, useState, useEffect } from 'react';

const LiveChat = () => {
	const iframeRef = useRef(null);
	const [open, setOpen] = useState(false);

	useEffect(() => {
		const waitWidget = setInterval(() => {
			const fcWidget = iframeRef?.current?.contentWindow?.fcWidget;

			if (fcWidget?.isLoaded?.()) {
				clearInterval(waitWidget);

        fcWidget.on('widget:opened', () => {        
          setOpen(true);
          window.dispatchEvent(new Event('freshchat:open'));
        });
        
        fcWidget.on('widget:closed', () => {
          setOpen(false);
          window.dispatchEvent(new Event('freshchat:close'));
        });
			}
		}, 500);

		return () => clearInterval(waitWidget);
	}, []);

	useEffect(() => {
		window.openFreshChat = () => {
			const tryOpen = () => {
				const fcWidget = iframeRef.current?.contentWindow?.fcWidget;

				if (fcWidget?.isLoaded?.()) {
					fcWidget.open();
				} else {
					setTimeout(tryOpen, 300);
				}
			};

			tryOpen();
		};

		return () => {
			delete window.openFreshChat;
		};
	}, []);

	return (
		<div
			style={{
				position: 'fixed',
				inset: 0,
				zIndex: 2147483647,
				pointerEvents: open ? 'auto' : 'none',
				background: 'transparent',
				overflow: 'hidden',
			}}>
			<iframe
				ref={iframeRef}
				src='/freshchatframe'
				title='chat-support'
				sandbox='allow-scripts allow-same-origin allow-forms'
				style={{
					width: '100%',
					height: '100%',
					border: 'none',
					display: open ? 'block' : 'none',
					overflow: 'hidden',
				}}
			/>
		</div>
	);
};

export default LiveChat;
